// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"ca4b6b6ef9e4b9058fbb","691":"dc53d28efe2800742dd1"}[chunkId] + ".js";
};